import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Exercise } from '@/models/LearnTypes';

interface BaseExerciseProps {
  id?: string;
  currentExercise: Exercise;
  isAnimating: boolean;
  onNext: () => void;
  isLastExercise: boolean;
  renderExerciseContent: () => React.ReactNode;
  renderActionButtons: () => React.ReactNode;
  onClose?: () => void;
  'data-manually-flipped'?: boolean;
  children?: React.ReactNode;
  initialAnimation?: boolean;
  isPerfect?: boolean;
  onImperfect?: () => void;
}

/**
 * Base container for all exercise types
 * Provides structure, and consistent styling
 */
const BaseExercise: React.FC<BaseExerciseProps> = ({
  id,
  currentExercise,
  isAnimating,
  onNext,
  isLastExercise,
  renderExerciseContent,
  renderActionButtons,
  onClose,
  initialAnimation,
  children,
  isPerfect,
  onImperfect,
  ...rest
}) => {
  return (
    <Card
      id={id}
      className="relative overflow-hidden border-none shadow-lg rounded-xl p-4"
      data-testid="exercise-card"
      data-exercise-id={currentExercise.id}
      data-word-id={currentExercise.id}
      data-word={currentExercise.word}
      data-is-perfect={isPerfect !== false ? 'true' : 'false'}
      {...rest}
    >
      {renderExerciseContent()}
      {renderActionButtons()}
      {children}
    </Card>
  );
};

export default BaseExercise;
